import {
  Button,
  Container,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import CircleSct from "./CircleSct";
import ViraSct from "./ViraSct";
import ServicesSct from "./ServicesSct";
import TopProjects from "./TopProjects";
import TrustedPartners from "./TrustedPartners";
import ContactUs from "../../../Components/ContactUs";
import { useGetProjectsQuery } from "../../../Store/api/rtk";
import TopProjectsSkeleton from "./HomeSkeletons/TopProjectsSkeleton";
import SeoHelmet from "../../../Components/SeoHelmet";

export default function Home() {
  const theme = useTheme();

  const projects = useGetProjectsQuery();

  return (
    <>
      <SeoHelmet
        title="ویرا تک آروند آریا | طراحی سایت، سئو، توسعه نرم‌افزار و تحول دیجیتال کسب‌وکارها"
        metaDescription="ویرا تک آروند آریا ارائه‌دهنده خدمات طراحی و توسعه وب‌سایت‌های حرفه‌ای، سئو تکنیکال، بهینه‌سازی موتورهای جستجو، طراحی رابط و تجربه کاربری، توسعه نرم‌افزارهای اختصاصی، اتوماسیون فرآیندهای کسب‌وکار، هوش تجاری و راهکارهای تحول دیجیتال. ما با ترکیب فناوری، استراتژی و داده به رشد پایدار برندها و افزایش فروش آنلاین کمک می‌کنیم."
        metaKeywords="ویرا تک, ویرا تک آروند آریا, vira tec, vira-tech, طراحی سایت, طراحی وب سایت, توسعه وب, برنامه نویسی اختصاصی, طراحی فروشگاه اینترنتی, طراحی پنل مدیریت, سئو, سئو تکنیکال, بهینه سازی سایت, افزایش رتبه گوگل, دیجیتال مارکتینگ, توسعه نرم افزار, نرم افزار اختصاصی, هوش تجاری, BI, تحلیل داده, UI UX, طراحی رابط کاربری, تحول دیجیتال, خدمات فناوری اطلاعات, شرکت طراحی سایت, شرکت نرم افزاری, طراحی سامانه سازمانی, اتوماسیون کسب و کار"
        ogTitle="ویرا تک آروند آریا | شریک فناوری کسب‌وکارهای در حال رشد"
        ogDescription="طراحی سایت حرفه‌ای، سئو، توسعه نرم‌افزارهای اختصاصی، هوش تجاری و راهکارهای تحول دیجیتال برای رشد برندها و کسب‌وکارها."
        // ogImage="https://vira-tec.ir/media/global/viraLogo.svg"
        ogUrl="https://vira-tec.ir"
      />
      <Stack sx={{ minHeight: "300vh" }}>
        {/* Circle Section */}
        <CircleSct />
        {/* Services */}
        <ServicesSct />
        {/* Vira */}
        <ViraSct />
        {/* Top Projects */}
        {projects?.isLoading || !projects?.isSuccess ? (
          <TopProjectsSkeleton />
        ) : (
          <TopProjects projects={projects?.data?.data?.d} />
        )}
        {/* Trusted Partners */}
        <TrustedPartners />
        {/* Contact us */}
        <ContactUs />
      </Stack>
    </>
  );
}
